import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F4F4F0] font-body">
      <header className="border-b border-white/10">
        <div className="mx-auto max-w-[900px] px-6 h-20 flex items-center justify-between">
          <Link to="/" className="font-display text-2xl text-white flex items-center gap-2">
            <span className="inline-block h-2.5 w-2.5 bg-[#FF3B00]" /> SBD<span className="text-[#FF3B00]">.</span>
          </Link>
          <Link to="/" className="font-tech text-xs uppercase tracking-[0.14em] text-neutral-400 hover:text-white flex items-center gap-2" data-testid="legal-back">
            <ArrowLeft size={14} /> Zurück zur Seite
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-[900px] px-6 py-16 lg:py-24">
        <h1 className="font-display text-5xl md:text-6xl uppercase text-white mb-12">{title}</h1>
        <div className="space-y-8 text-neutral-300 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:text-[15px] [&_a]:text-[#FF3B00] [&_a:hover]:underline">
          {children}
        </div>
      </main>
      <footer className="border-t border-white/10 py-8">
        <div className="mx-auto max-w-[900px] px-6 flex flex-wrap gap-x-6 gap-y-2 text-neutral-600 font-tech text-xs uppercase tracking-[0.14em]">
          <span>© {new Date().getFullYear()} Saba Business Development</span>
          <Link to="/impressum" className="hover:text-neutral-300">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-neutral-300">Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
}
